import { UrlFilterSchema } from "@core/hooks"

/**
 * Единая combined-схема URL-состояния страницы «Материалы»: фильтры +
 * пагинация в одной схеме — любое изменение пишется ОДНИМ функциональным
 * обновлением URL (сброс страницы — в той же записи, §2.7 / E3).
 */
export const CONTENTS_PAGE_URL_SCHEMA = {
  campaigns: "numberArray",
  orders: "numberArray",
  agents: "numberArray",
  orderDateFrom: "string",
  orderDateTo: "string",
  page: "number",
  pageSize: "number",
} as const satisfies UrlFilterSchema

// Свои опции вместо GRID_PAGE_SIZE_OPTIONS: 500/1000 разъехались бы
// с клиентским капом limit ≤ 100 (buildContentsQuery).
export const CONTENTS_PAGE_SIZE_OPTIONS = [25, 50, 100]
export const CONTENTS_PAGE_SIZE_DEFAULT = 50
